var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 55,
    viewBox: "0 0 77 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8017 54.0464C46.6071 54.0464 38.5002 54.0464 38.5002 54.0464H27.099C27.099 54.0464 22.6157 54.0464 19.4982 54.0464C9.00249 54.0464 0.496094 45.4931 0.496094 34.9438C0.496094 26.2786 6.23383 18.9584 14.1019 16.6209C18.2066 7.16664 27.5889 0.559082 38.5002 0.559082C52.0466 0.559082 63.2326 10.7428 64.8878 23.9113C71.5534 25.5324 76.5043 31.5672 76.5043 38.7643C76.5043 47.2038 69.6977 54.0464 61.3027 54.0464C57.6359 54.0464 55.512 54.0464 51.8017 54.0464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLg);
export default __webpack_public_path__ + "static/media/cloud-lg.d49e0bd90f7a20a64e8ddaf1382513b7.svg";
export { ForwardRef as ReactComponent };